import { Loader } from '@googlemaps/js-api-loader'

export const GOOGLE_MAPS_API_KEY = 'AIzaSyC5Dp7msFBr2C7uEwVDEdU1Nm-XS1m636I'

let googleMapsPromise = null;

export const loadGoogleMaps = () => {
  if (googleMapsPromise) return googleMapsPromise;
  const loader = new Loader({
    apiKey: GOOGLE_MAPS_API_KEY,
    version: 'weekly',
    libraries: ['places', 'marker', 'geometry'],
    language: 'en'
  });
  googleMapsPromise = loader.load();
  return googleMapsPromise;
}
